import { RefObject, useEffect, useState } from 'react';

export const useIsStuck = ({ isSticky }: { isSticky?: boolean }, ref: RefObject<HTMLElement>) => {
  const [isCurrentlySticking, setIsCurrentlySticking] = useState(false);

  useEffect(() => {
    if (!isSticky || !ref?.current) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        // @ts-ignore
        setIsCurrentlySticking(entry.intersectionRatio < 1);
      },
      {
        rootMargin: '60px 0px 0px 0px',
        threshold: [1],
      },
    );

    observer.observe(ref.current);

    return () => {
      if (!ref?.current) {
        return;
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
      observer.unobserve(ref?.current);
    };
  }, [ref, isSticky]);

  return isCurrentlySticking;
};
